import { render, staticRenderFns } from "./ContactUsPopup.vue?vue&type=template&id=2d8a9d7c&scoped=true&"
import script from "./ContactUsPopup.vue?vue&type=script&lang=ts&"
export * from "./ContactUsPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ContactUsPopup.vue?vue&type=style&index=0&id=2d8a9d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8a9d7c",
  null
  
)

export default component.exports